import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalFooter from 'LuxKit/Modal/ModalFooter'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import BodyText from 'LuxKit/Typography/BodyText'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

export type ExperienceIngressoSeatTextWarningModalResult = 'continue' | 'stay'

export interface IngressoSeatTextWarningGroup {
  ticketName: string
  warningTexts: Array<string>
}

interface Props {
  warningGroups: Array<IngressoSeatTextWarningGroup>
  additionalWarnings?: Array<string>
}

const WarningList = styled.ul`
  margin: 0;
  padding-inline-start: 1.25rem;
`

function ExperienceIngressoSeatTextWarningModal({ warningGroups, additionalWarnings = [] }: Props) {
  const intl = useIntl()
  const { resolve } = useModalElementContext<ExperienceIngressoSeatTextWarningModalResult>()

  const handleContinue = () => {
    resolve('continue')
  }

  const handleStay = () => {
    resolve('stay')
  }

  return (
    <ModalBase size="S" onClose={handleStay}>
      <ModalHeader
        title={intl.formatMessage({
          id: 'EMjaywAbHMAjha28OCvw',
          defaultMessage: 'Review ticket warnings',
        })}
        subtitle={intl.formatMessage({
          id: '6RYLRmzq5BjNhQo7PB-u',
          defaultMessage: 'Some of your selected tickets include important information from the venue.',
        })}
      >
        {warningGroups.map(group => (
          <BodyTextBlock key={group.ticketName} variant="medium" colour="neutral-two">
            <BodyText variant="medium" weight="bold">{group.ticketName}</BodyText>
            <WarningList>
              {group.warningTexts.map(warningText => (
                <li key={warningText}>
                  <BodyText variant="medium" colour="warning">{warningText}</BodyText>
                </li>
              ))}
            </WarningList>
          </BodyTextBlock>
        ))}
        {additionalWarnings.map(warningText => (
          <BodyText key={warningText} variant="medium" colour="warning">{warningText}</BodyText>
        ))}
      </ModalHeader>
      <ModalFooter
        primaryActionProps={{
          children: intl.formatMessage({
            id: '-Qr7gOK-myTp1eWteFhz',
            defaultMessage: 'Continue to checkout',
          }),
          onClick: handleContinue,
        }}
        secondaryActionProps={{
          children: intl.formatMessage({
            id: 'Hq1QuLSWYLWSiErx2IZF',
            defaultMessage: 'Choose different tickets',
          }),
          onClick: handleStay,
        }}
      />
    </ModalBase>
  )
}

export default ExperienceIngressoSeatTextWarningModal
